var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c(
        "div",
        {
          class: ["modal-dialog", _vm.modalClass],
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              { staticClass: "modal-header" },
              [
                _vm._t("header", [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.headerText) + "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.showCloseButton
                    ? _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.onClickCloseModal }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ],
              2
            ),
            _vm._v(" "),
            _vm.showBody
              ? _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2)
              : _vm._e(),
            _vm._v(" "),
            _vm.showFooter
              ? _c(
                  "div",
                  { class: ["modal-footer", _vm.footerClasses] },
                  [
                    _vm._t("footer", [
                      _vm.cancelButtonText
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-light",
                              attrs: {
                                disabled: _vm.isSubmitted,
                                type: "button"
                              },
                              on: { click: _vm.onClickCancel }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.cancelButtonText) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sumitButtonText
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-web",
                              attrs: {
                                disabled: _vm.isSubmitted,
                                type: "button"
                              },
                              on: { click: _vm.onClickSubmit }
                            },
                            [
                              !_vm.isSubmitted
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.sumitButtonText) +
                                        "\n            "
                                    )
                                  ]
                                : _c("i", {
                                    staticClass: "fas fa-spinner spin"
                                  })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ],
                  2
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c5948e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c5948e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModal.vue
// module id = null
// module chunks = 